import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/frontier-exposure-analysis/create')({
  beforeLoad: () => getTitleContextSlice('New App Configuration'),
});
